"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.options = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _text = _interopRequireDefault(require("lemon-db/dist/options/text.json"));

var _redraft = _interopRequireDefault(require("redraft"));

var _classnames = _interopRequireDefault(require("classnames"));

var _uniqueId = _interopRequireDefault(require("lodash/uniqueId"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var options = _text["default"];
exports.options = options;

var factory = function factory(_ref) {
  var identifier = _ref.identifier;

  var TextRedraft = /*#__PURE__*/function (_React$Component) {
    _inherits(TextRedraft, _React$Component);

    var _super = _createSuper(TextRedraft);

    function TextRedraft() {
      var _this;

      _classCallCheck(this, TextRedraft);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));

      _defineProperty(_assertThisInitialized(_this), "sanitizeUrl", function (url) {
        if (!url) return '';
        var trimmed = url.trim();

        if (trimmed.search(/^http[s]?:\/\//) === -1 && !_this.hasLinkLogic(trimmed)) {
          trimmed = "//".concat(trimmed);
        }

        return trimmed;
      });

      _defineProperty(_assertThisInitialized(_this), "isEmptyDraft", function (draft) {
        return !draft || !draft.blocks || draft.blocks.length === 1 && draft.blocks[0].text === '';
      });

      _defineProperty(_assertThisInitialized(_this), "addLineBreaks", function (children) {
        return children.map(function (child) {
          return [child, /*#__PURE__*/_react["default"].createElement("br", {
            key: (0, _uniqueId["default"])('linebreak-')
          })];
        });
      });

      return _this;
    }

    _createClass(TextRedraft, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        window.redraft = _redraft["default"];
      }
    }, {
      key: "hasLinkLogic",
      value: function hasLinkLogic(url) {
        if (!url) return false;
        return url.indexOf('mailto:') === 0 || url.indexOf('tel:') === 0;
      }
    }, {
      key: "render",
      value: function render() {
        var _this$props = this.props,
            draft = _this$props.draft,
            color = _this$props.color;
        var isEmpty = this.isEmptyDraft(draft);
        if (isEmpty) return null;
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: this.wrapperClass,
          style: {
            color: color
          }
        }, (0, _redraft["default"])(draft, this.redraftConfig));
      }
    }, {
      key: "inlineStyles",
      get: function get() {
        return {
          BOLD: function BOLD(children, _ref2) {
            var key = _ref2.key;
            return /*#__PURE__*/_react["default"].createElement("strong", {
              key: key
            }, children);
          },
          ITALIC: function ITALIC(children, _ref3) {
            var key = _ref3.key;
            return /*#__PURE__*/_react["default"].createElement("em", {
              key: key
            }, children);
          },
          UNDERLINE: function UNDERLINE(children, _ref4) {
            var key = _ref4.key;
            return /*#__PURE__*/_react["default"].createElement("u", {
              key: key
            }, children);
          }
        };
      }
    }, {
      key: "blocks",
      get: function get() {
        var _this2 = this;

        var _this$props2 = this.props,
            theme = _this$props2.theme,
            inherit = _this$props2.inherit;
        return {
          SIZE_CHECKBOX: function SIZE_CHECKBOX(children, _ref5) {
            var key = _ref5.key;
            return /*#__PURE__*/_react["default"].createElement("div", {
              key: key,
              className: inherit ? theme.inherit : theme.checkbox
            }, _this2.addLineBreaks(children));
          },
          SIZE_S: function SIZE_S(children, _ref6) {
            var key = _ref6.key;
            return /*#__PURE__*/_react["default"].createElement("div", {
              key: key,
              className: inherit ? theme.inherit : theme.small
            }, _this2.addLineBreaks(children));
          },
          SIZE_M: function SIZE_M(children, _ref7) {
            var key = _ref7.key;
            return /*#__PURE__*/_react["default"].createElement("div", {
              key: key,
              className: inherit ? theme.inherit : theme.medium
            }, _this2.addLineBreaks(children));
          },
          SIZE_L: function SIZE_L(children, _ref8) {
            var key = _ref8.key;
            return /*#__PURE__*/_react["default"].createElement("div", {
              key: key,
              className: inherit ? theme.inherit : theme.large
            }, _this2.addLineBreaks(children));
          },
          SIZE_XL: function SIZE_XL(children, _ref9) {
            var key = _ref9.key;
            return /*#__PURE__*/_react["default"].createElement("div", {
              key: key,
              className: inherit ? theme.inherit : theme.xLarge
            }, _this2.addLineBreaks(children));
          },
          unstyled: function unstyled(children, _ref10) {
            var keys = _ref10.keys;
            return /*#__PURE__*/_react["default"].createElement("div", {
              key: keys[0]
            }, _this2.addLineBreaks(children));
          }
        };
      }
    }, {
      key: "noFollowAttributes",
      get: function get() {
        return {
          target: '_blank',
          rel: 'noopener noreferrer'
        };
      }
    }, {
      key: "entities",
      get: function get() {
        var _this3 = this;

        var theme = this.props.theme;
        return {
          LINK: function LINK(children, entity, _ref11) {
            var key = _ref11.key;
            var attributes = {
              key: key,
              href: _this3.sanitizeUrl(entity.url),
              className: theme.anchor
            };

            if (!_this3.hasLinkLogic(entity.url)) {
              Object.assign(attributes, _this3.noFollowAttributes);
            }

            return /*#__PURE__*/_react["default"].createElement("a", attributes, children);
          }
        };
      }
    }, {
      key: "wrapperClass",
      get: function get() {
        var _cn;

        var _this$props3 = this.props,
            preventDesktopBehaviour = _this$props3.preventDesktopBehaviour,
            theme = _this$props3.theme,
            align = _this$props3.align,
            inherit = _this$props3.inherit;
        return (0, _classnames["default"])(theme.wrapper, (_cn = {}, _defineProperty(_cn, theme.preventDesktop, preventDesktopBehaviour), _defineProperty(_cn, theme.left, align === 'left'), _defineProperty(_cn, theme.center, align === 'center'), _defineProperty(_cn, theme.right, align === 'right'), _defineProperty(_cn, theme.inherit, inherit), _cn));
      }
    }, {
      key: "redraftConfig",
      get: function get() {
        return {
          inline: this.inlineStyles,
          blocks: this.blocks,
          entities: this.entities
        };
      }
    }]);

    return TextRedraft;
  }(_react["default"].Component);

  TextRedraft.displayName = identifier;
  TextRedraft.themeShape = {
    draft: _propTypes["default"].string,
    wrapper: _propTypes["default"].string.isRequired,
    small: _propTypes["default"].string.isRequired,
    medium: _propTypes["default"].string.isRequired,
    large: _propTypes["default"].string.isRequired,
    xLarge: _propTypes["default"].string.isRequired,
    preventDesktop: _propTypes["default"].string.isRequired,
    left: _propTypes["default"].string.isRequired,
    right: _propTypes["default"].string.isRequired,
    center: _propTypes["default"].string.isRequired
  };
  TextRedraft.propTypes = {
    inherit: _propTypes["default"].bool,
    align: _propTypes["default"].oneOf(Object.values(options.align)),
    color: _propTypes["default"].string,
    draft: _propTypes["default"].shape({
      blocks: _propTypes["default"].array.isRequired,
      entityMap: _propTypes["default"].object.isRequired
    }).isRequired,
    theme: _propTypes["default"].shape(TextRedraft.themeShape).isRequired,
    preventDesktopBehaviour: _propTypes["default"].bool.isRequired
  };
  TextRedraft.defaultProps = {
    inherit: false,
    align: 'left',
    preventDesktopBehaviour: false
  };
  return TextRedraft;
};

var _default = factory;
exports["default"] = _default;